module.exports = __webpack_public_path__ + "img/banner-poster.e9bd0ff7.jpg";